import React from "react";
import { RadioButton } from 'material-ui';

export default function RadioButtonOption({ label, checked, onChange }) {
  return (
    <div className="medium-12" style={{ marginBottom: "5px" }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <RadioButton
          checked={checked}
          onClick={onChange}
          color="default"
          style={{ marginRight: "10px", width: "1%" }}
        />
        <span>{label}</span>
      </div>
    </div>
  );
}